import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

export const submitClaimIntake = async (claimData) => {
  const response = await api.post('/api/claims/intake', claimData);
  return response.data;
};

export const submitClaimWithDocuments = async (claimData, files, documentTypes) => {
  const formData = new FormData();
  formData.append('claim_data', JSON.stringify(claimData));
  formData.append('document_types', JSON.stringify(documentTypes));
  files.forEach((file) => formData.append('files', file));

  const response = await api.post('/api/claims/intake-with-documents', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getClaim = async (claimId) => {
  const response = await api.get(`/api/claims/${claimId}`);
  return response.data;
};

export const getClaimAudit = async (claimId) => {
  const response = await api.get(`/api/claims/${claimId}/audit`);
  return response.data;
};

export const getProcessingSummary = async (claimId) => {
  const response = await api.get(`/api/claims/${claimId}/processing-summary`);
  return response.data;
};

export const listClaims = async (status = null, limit = 50) => {
  const params = { limit };
  if (status) params.status = status;
  const response = await api.get('/api/claims', { params });
  return response.data;
};

export const parseDocument = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post('/api/claims/parse-document', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const orchestrateClaim = async (claimId, prompt, conversationHistory = []) => {
  const response = await api.post(`/api/claims/${claimId}/orchestrate`, {
    prompt,
    conversation_history: conversationHistory,
  });
  return response.data;
};

export const processClaimPipeline = async (claimId) => {
  const response = await api.post(`/api/claims/${claimId}/process`);
  return response.data;
};

export const reviewClaim = async (claimId, action, comments) => {
  const response = await api.post(`/api/claims/${claimId}/review`, { action, comments });
  return response.data;
};

export const rerunClaim = async (claimId, comments) => {
  const response = await api.post(`/api/claims/${claimId}/rerun`, { comments });
  return response.data;
};

export const chatWithClaim = async (claimId, question, conversationHistory = []) => {
  const response = await api.post(`/api/claims/${claimId}/orchestrate`, {
    prompt: question,
    conversation_history: conversationHistory,
  });
  return response.data;
};

export default api;
